var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPaperclip = function SvgIconPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.562 3.436a3.625 3.625 0 0 1 5.127 5.127l-.014.014-8.981 8.644a1 1 0 1 1-1.387-1.441l8.974-8.637a1.625 1.625 0 0 0-2.305-2.292L5.779 14.03a3.495 3.495 0 0 0 4.942 4.942l7.698-7.679a1 1 0 0 1 1.413 1.416l-7.696 7.677a5.496 5.496 0 0 1-7.77-7.77z"
  })));
};
export default SvgIconPaperclip;